var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechHisto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.32,
    height: 101.323,
    viewBox: "0 0 101.32 101.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 74.528,
    height: 74.536,
    fill: "#3734a9",
    stroke: "#3734a9",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flech-histo",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 0, 36.132)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_291",
    "data-name": "Groupe 291",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_362",
    "data-name": "Trac\\xE9 362",
    d: "M73.713,63.1q-5.269,5.315-10.584,10.585a2.584,2.584,0,0,1-3.85-.016Q54,68.422,48.753,63.143a2.655,2.655,0,1,1,3.773-3.73c1.8,1.77,3.573,3.561,5.355,5.347.185.185.345.393.637.729a66.808,66.808,0,0,0-1.759-18.938,36.329,36.329,0,0,0-6.951-14.363,21.892,21.892,0,0,0-4.932-4.452c.094,1.066.207,2.028.259,2.993C45.61,39.63,38.708,46.22,30.1,45.1A13.324,13.324,0,0,1,18.638,32.559,12.92,12.92,0,0,1,29.1,19.108a23.188,23.188,0,0,1,5.55-.327,29.128,29.128,0,0,0-5.67-5.257,44.95,44.95,0,0,0-26.1-8.2A2.668,2.668,0,1,1,2.889,0,51.115,51.115,0,0,1,27.344,6.136,36,36,0,0,1,41.979,20a1.523,1.523,0,0,0,.915.639,27.146,27.146,0,0,1,11.534,8.688,43.444,43.444,0,0,1,7.949,17.792,70.742,70.742,0,0,1,1.5,16.844c-.008.431,0,.863,0,1.536.332-.366.5-.571.69-.758,1.782-1.786,3.556-3.578,5.353-5.348a2.652,2.652,0,1,1,3.8,3.7M39.869,30.541a19.069,19.069,0,0,0-1.252-5.226.947.947,0,0,0-.729-.677,24.364,24.364,0,0,0-4.87-.653,10.323,10.323,0,0,0-6.036,1.687,7.6,7.6,0,0,0-2.815,8.056,7.618,7.618,0,0,0,6.19,6c5.62,1.119,10.052-3.221,9.512-9.19",
    transform: "translate(0 0)",
    fill: "#3734a9",
    stroke: "#3734a9",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechHisto);
export default __webpack_public_path__ + "static/media/flech-histo.c8a12d8de62968bd5cc477e7fc962aeb.svg";
export { ForwardRef as ReactComponent };